/**
 * Comp `.modpick` — the rail's module scope picker.
 *
 * Demo page: NextAdmin `/tables/data-tables` header select (`FilterSelect` pattern), on the vendored TailGrids
 * `Select`, which keeps the option list keyboard- and screen-reader-native.
 */
import React from 'react';
import {
  Select,
  SelectContent,
  SelectIndicator,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '../../components/tailgrids/core/select.js';
import { useActiveModule } from '../../hooks/useActiveModule.js';
import { useEnabledModules } from '../../modules/useEnabledModules.js';

export const SimpleModuleSelect: React.FC = () => {
  const { activeModuleId, setActiveModule } = useActiveModule();
  const { data: modules } = useEnabledModules();

  const options = [
    { id: 'all', label: '✦ Everything' },
    ...(modules ?? []).map((m) => ({ id: m.id, label: m.id === 'core' ? 'Platform' : m.displayName })),
  ];

  return (
    <Select
      aria-label="Module"
      className="mb-1.5 w-full"
      value={activeModuleId}
      onChange={(next) => next !== null && setActiveModule(String(next))}
    >
      <SelectTrigger className="w-full border-border-secondary bg-input-background py-2">
        <SelectValue />
        <SelectIndicator />
      </SelectTrigger>
      <SelectContent className="min-w-(--trigger-width)">
        {options.map((o) => (
          <SelectItem key={o.id} id={o.id} textValue={o.label}>
            {o.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};
